<div class="rejects-dialog-wrapper">
    <h1 class="view-rejects-title">View Requested Updates</h1>
    <mat-progress-bar *ngIf="(loadingRejections$|async) || downloadingPdf" mode="indeterminate"></mat-progress-bar>

    <cdk-virtual-scroll-viewport #rejectedAssetsCarousel
                                 [itemSize]="assetListScroll.measureRenderedContentSize() / (rejectedAssets$ | async)[jobId]?.length || 0"
                                 class="view-rejects-wrapper">
        <div class="product-asset-wrapper"
             *ngFor="let rejection of (rejectedAssets$ | async)[jobId]"
             [ngClass]="{'selected-asset': currentIndex === i}">
            <div class="product-asset" [ngStyle]="{'background-image': insertUrl(rejection.url)}">
            </div>
            <div class="form-field fill-field">
                <mat-form-field appearance="outline">
                        <textarea #rejectText matInput placeholder="Type your resending reasons here..."
                                  [value]="rejection.finalRejectReason ? rejection.finalRejectReason : ''"
                                  disabled></textarea>
                </mat-form-field>
            </div>
        </div>
    </cdk-virtual-scroll-viewport>

  <div class="rejects-footer">
    <div class="rejects-footer-btns">
      <button mat-button class="btn btn-red" (click)="closeDialog()">Close</button>
      <button mat-raised-button class="btn btn-blue" (click)="downloadPDF()" [disabled]="!loadedRejections || downloadingPdf">Download PDF</button>
    </div>
  </div>
</div>
